<template>
	<v-dialog v-model="addShareUserDialog" width="700">
    <customDialog>
      <template v-slot:title>
        {{ts('addShareUserWith')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img"
						@click="closeShareUserDialog">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10">
						<v-col class="ma-0 pa-0 pb-3" cols="12" align="left">
							<v-col class="ma-0 pa-0 pb-5" cols="12">
								<v-row id="add_box" class="ma-0 pa-2 pl-0 pr-0" align="center">
									<v-col class="ma-0 pa-0" cols="5">
										{{ts('nameOfThePersonToInvite')}}
									</v-col>
									<v-col class="ma-0 pa-0" cols="7">
										<input id="user_input" :placeholder="ts('shareUserName')"
											style="width:100%;" v-model="userName">
									</v-col>
								</v-row>
								<v-row id="add_box" class="ma-0 pa-2 pl-0 pr-0" align="center">
									<v-col class="ma-0 pa-0" cols="5">
										{{t('emailAddress')}}
									</v-col>
									<v-col class="ma-0 pa-0" cols="7">
										<input id="user_input" :placeholder="t('emailAddress')"
											style="width:100%;" v-model="mailAddress">
									</v-col>
								</v-row>
								<v-row id="add_box" class="ma-0 pa-2 pl-0 pr-0" align="center">
									<v-col class="ma-0 pa-0" cols="5">
										{{ts('authority')}}
									</v-col>
									<v-col class="ma-0 pa-0" cols="7" align="right">
										<v-col class="ma-0 pa-0" cols="auto" style="width:12rem;">
				      				<v-select background-color="#272727" dark
				      					:items="userStatus" dense hide-details outlined 
				      					item-text="label" item-value="value" v-model="selectedUserStatus"
				      				></v-select>
				      			</v-col>
									</v-col>
								</v-row>
							</v-col>

							<v-col class="ma-0 pa-0 mt-10" cols="12">
								<v-row class="ma-0 pa-0" align="center" justify="center">
									<v-btn width="8rem" height="auto" class="ma-0 pa-2" 
										id="grey_btn" elevation="0" @click="closeShareUserDialog">
											{{t('cancel')}}
									</v-btn>
									<v-btn :loading="loading" width="8rem" height="auto" class="ma-0 pa-2 ml-2" 
										id="blue_btn" elevation="0" @click="addShareUser">
											{{t('add')}}
									</v-btn>
								</v-row>
							</v-col>
						</v-col>
          </v-col>
        </v-row>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import CustomDialog from '@/components/Modal.vue';
export default {
	props: {
		dialogVisible: Boolean,
    fromBranchShare: Boolean,
    unisCustomerCd: String
	},
	components: {
		CustomDialog
	},
	mixins: [mixin.common],
	data: () => ({
    addShareUserDialog: false,
		selectedUserStatus: "",
    userName: '',
    mailAddress: '',
		loading: false,
    addBranchShareUser: false,
	}),
	watch: {
		dialogVisible: function(item) {
			this.addShareUserDialog = item;
		},
		addShareUserDialog: function(item) {
			this.$emit('visible', item);
      if(item == false) {
        this.addBranchShareUser = false;
      }
		},
    fromBranchShare: function(item) {
      this.addBranchShareUser = item;
    },
    addBranchShareUser: function(item) {
      this.$emit('branchShareUser', item);
    }
	},
	computed: {
		userStatus() {
      let role = this.roleCheck(this.$store.getters.getRole);
      if(this.addBranchShareUser == true) {
        //branch role
        this.selectedUserStatus = "31";
			  return [
			  	{ label: this.$i18n.t('lang.settings.admin'), value: "31" },
			  	{ label: this.$i18n.t('lang.settings.normalUser'), value: "32" },
			  	{ label: this.$i18n.t('lang.settings.viewer'), value: "33" },
			  ];
      } else {
        if(role == "private") {
          this.selectedUserStatus = "1";
			    return [
			    	{ label: this.$i18n.t('lang.settings.admin'), value: "1" },
			    	{ label: this.$i18n.t('lang.settings.normalUser'), value: "2" },
			    	{ label: this.$i18n.t('lang.settings.viewer'), value: "3" },
			    ];
        } 
        else if(role == "main") {
          this.selectedUserStatus = "11";
			    return [
			    	{ label: this.$i18n.t('lang.settings.admin'), value: "11" },
			    	{ label: this.$i18n.t('lang.settings.normalUser'), value: "12" },
			    	{ label: this.$i18n.t('lang.settings.viewer'), value: "13" },
			    ];
        }
        else if(role == "head") {
          this.selectedUserStatus = "21";
			    return [
			    	{ label: this.$i18n.t('lang.settings.admin'), value: "21" },
			    	{ label: this.$i18n.t('lang.settings.normalUser'), value: "22" },
			    	{ label: this.$i18n.t('lang.settings.viewer'), value: "23" },
			    ];
        }
        else { //branch role
          this.selectedUserStatus = "31";
			    return [
			    	{ label: this.$i18n.t('lang.settings.admin'), value: "31" },
			    	{ label: this.$i18n.t('lang.settings.normalUser'), value: "32" },
			    	{ label: this.$i18n.t('lang.settings.viewer'), value: "33" },
			    ];
        }
      }
		}
	},
	methods: {
		ts(t) {
      return this.$t("lang.settings." + t);
    },
    async addShareUser() {
			if(this.userName == '') {
				this.showToastMessage(this.tmb('inputValueCannotBeBlank'));
				return;
			}
			if(this.validateEmail(this.mailAddress) == false || this.mailAddress == '') {
				this.showToastMessage(this.tmb('notEmailFormat'));
				return;
			}
      this.loading = true;
      let params = {
        name: this.userName,
        destination: this.mailAddress,
        role: this.selectedUserStatus,
        unisCustomerCd: this.unisCustomerCd,
      };
      await this.networkController.addShareUser(params)
      .then(async(res) => {
				this.showToastMessage(this.tmb('saved'));
        this.loading = false;
				this.userName = '';
				this.mailAddress = '';
        this.addShareUserDialog = false;
      }).catch(error => {
				this.showToastMessage(this.tmb('requestFail'));
        this.loading = false;
      });
    },
    closeShareUserDialog() {
			this.userName = '';
			this.mailAddress = '';
      this.addShareUserDialog = false;
    }
	}
}
</script>

<style lang="scss" scoped>
#add_box {
	border-bottom: 1px solid #6A6A6A;
}
.v-list{
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__content{
    color: white;
  }

	// Select box v화살표 위치
	.v-input__slot {
		padding-right: 2px !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
	// Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
#user_list {
	border: 1px solid #4A4A4A;
	overflow: auto;
	min-height: 350px;
	max-height: 350px;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
#user_input {
	background-color: #272727;
	border: 1px solid #4A4A4A;
	border-radius: 4px;
	color: white;
	padding: 5px;
}
#user_item {
	border-bottom: 1px solid #4A4A4A;
}
</style>